<div class="chips">
  @for (chip of [1, 2, 3, 4]; track chip) {
    <ngx-skeleton-loader [theme]="{ height: '32px', width: '120px', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
  }
</div>

@for (group of [1, 2]; track group) {
  <div class="group">
    <div class="group-header">
      <ngx-skeleton-loader [theme]="{ height: '40px', width: '40px', margin: '0px' }" appearance="circle"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '18px', width: '200px', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
    </div>

    <div class="tiles">
      @for (tile of [1, 2, 3, 4]; track tile) {
        <ngx-skeleton-loader [theme]="{ height: '52px', width: '100%', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
      }
    </div>
  </div>
}
